import React, { useEffect, useState } from "react";
import { Link, Link as LinkRRD, useParams } from "react-router-dom";

import { Breadcrumbs, Button, Card, Paper, Typography } from "@mui/material";
import { Box, display, minWidth, Stack } from "@mui/system";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Helmet } from "react-helmet-async";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

import LoadingUI from "../../comman/LoadingUI";
import { useNavigate } from "react-router-dom";
import NoDataFound from "../../comman/NoDataFound";
import SnackBarUI from "../../comman/SnackBarUI";
import Appbar from "../../components/Appbar";
import { dateFormatStartFun } from "../../helper/dateConverter";
import Body from "../../layout/Body";

import { allDeviceInfoAction } from "../../redux/toolkit/users/deviceInfo";
import { useStyles } from "../../theme/theme";
import { min } from "lodash";
import { userFromSameDeaviceAction } from "../../redux/toolkit/users/userFromSameDevice";
import { vi } from "date-fns/locale";
import { highConvertingSurveyAction } from "../../redux/toolkit/users/highConvertingSurvey";
import { render } from "@testing-library/react";

const breadcrumb = (
  <Stack>
    <Breadcrumbs
      separator={
        <NavigateNextIcon sx={{ color: "#5E6C8A" }} fontSize="small" />
      }
      aria-label="breadcrumb"
    >
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/"
      >
        Home
      </Link>
      <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/admin"
      >
        User
      </Link>
      {/* <Link
        underline="hover"
        sx={{ color: "#5E6C8A" }}
        color="inherit"
        href="/devices-info"
      >
        Device Info
      </Link> */}
    </Breadcrumbs>
    <Typography sx={{ color: "#5E6C8A" }} variant="h5">
      High Converting Survey
    </Typography>
  </Stack>
);

const HigestConvertingSurvey = () => {
  const dispatch = useDispatch();
  //   const id  = useParams()?.id;

  const usreFromsameDevice = useSelector((state) => state.highConvertingSurvey);
  let { data, loading, total, message, status } = usreFromsameDevice;

  console.log("total==================================>",total)

  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });
  const classes = useStyles();
  const [snack, setSnack] = useState(false);

  const adminColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      maxWidth: 50,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.id) + 1;
        return serialNumber;
      },
    },

    {
      field: "survey_id",
      headerName: "Survey Id",
      filterable: false,
      flex: 1,
      maxWidth: 350,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.survey_id}</Typography>;
      },
    },

    {
      field: "partner_id",
      headerName: "Partner Id",
      filterable: false,
      flex: 1,
      maxWidth: 350,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.partner_id}</Typography>;
      },
    },

    {
      field: "attemptedSurvey",
      headerName: "Attempted Survey",
      filterable: false,
      flex: 1,
      maxWidth: 400,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.attemptedSurvey}</Typography>;
      },
    },

    {
      field: "completedSurvey",
      headerName: "Completed Survey",
      filterable: false,
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.completedSurvey}</Typography>;
      },
    },

    {
      field: "completionRate",
      headerName: "Completion Rate",
      filterable: false,
      flex: 1,
      maxWidth: 350,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return <Typography>{params?.row?.completionRate}</Typography>;
      },
    },
  ];

  useEffect(() => {
    dispatch(highConvertingSurveyAction({page: pageState.page, limit: pageState.pageSize}));
  }, [pageState.page, pageState.pageSize]);

  return (
    <>
      <>
        <Helmet>
          <title>Real Opinion Admin | User</title>
        </Helmet>
        <Appbar breadcrumb={breadcrumb} />

        <Body>
          <Card sx={{ my: 2 }}>
            <Paper
              sx={{
                bgcolor: "#fff",
                "& .super-app-theme--header": {
                  bgcolor: "#071D45",
                  color: "#fff",
                },
              }}
              elevation={0}
            >
              <DataGrid
                className={classes.root}
                getRowHeight={() => "auto"}
                sx={{ border: 0 }}
                rows={data}
                autoHeight
                columns={adminColumns}
                // getRowId={(row) => row._id}
                getRowId={(row) => `${row._id.surveyId}_${row._id.partnerId}`}
                disableSelectionOnClick
                experimentalFeatures={{ newEditingApi: true }}
                pagination
                // pageSize={pageSize}
                // onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                rowsPerPageOptions={[25, 50, 100]}
                disableColumnSelector
                loading={loading ? <LoadingUI /> : false}
                // loading={loading ? <Loader /> : false}
                components={{
                  NoRowsOverlay: () => <NoDataFound />,
                  // Toolbar: GridToolbar,
                }}
                rowCount={total || 0}
                paginationModel={setPageState}
                page={pageState.page}
                pageSize={pageState.pageSize}
                paginationMode="server"
                onPageChange={(newPage) => {
                  setPageState((old) => ({ ...old, page: newPage }));
                }}
                onPageSizeChange={(newPageSize) =>
                  setPageState((old) => ({ ...old, pageSize: newPageSize }))
                }
              />
            </Paper>
          </Card>
        </Body>

        <SnackBarUI
          state={snack}
          setState={setSnack}
          status={status}
          message={message}
        />
      </>
    </>
  );
};

export default HigestConvertingSurvey;
